// n: if you're reading this, devtools fetched the source map. nobody else will ever see these.
// n: the public script.js is this file with my notes stripped out.

const currentYear = document.querySelector("[data-current-year]");

if (currentYear) {
  currentYear.textContent = String(new Date().getFullYear());
}

// n: the console is for people like you. curious ones.
console.log(
  "%cStill reading?",
  "font: 700 20px system-ui, sans-serif; color: #0a4df5;",
);
console.log(
  "Most visitors read the page. The machines read everything else.\n" +
    "Start with whatever the robots are told not to see.",
);

// n: switch tabs and the title asks not to be forgotten. pathetic? probably. it's also true.
const pageTitle = document.title;
document.addEventListener("visibilitychange", () => {
  document.title = document.hidden
    ? "Nathan Wagner — still waiting for a callback"
    : pageTitle;
});

// The vault message is sealed with tools/seal-vault.mjs; the phrase is the key.
// n: the log is the only honest thing on this site. that's why it's locked.
const vault = document.querySelector("[data-vault]");

function fromBase64(value) {
  return Uint8Array.from(atob(value), (character) => character.charCodeAt(0));
}

// Keep in sync with normalizePhrase in tools/seal-vault.mjs.
function normalizePhrase(value) {
  return value.toUpperCase().replace(/[^A-Z]+/g, " ").trim();
}

async function openVault(phrase) {
  const { salt, iv, payload } = vault.dataset;
  const material = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(normalizePhrase(phrase)),
    "PBKDF2",
    false,
    ["deriveKey"],
  );
  const key = await crypto.subtle.deriveKey(
    { name: "PBKDF2", hash: "SHA-256", salt: fromBase64(salt), iterations: 250000 },
    material,
    { name: "AES-GCM", length: 256 },
    false,
    ["decrypt"],
  );
  const plain = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv: fromBase64(iv) },
    key,
    fromBase64(payload),
  );
  return new TextDecoder().decode(plain);
}

if (vault) {
  const status = vault.querySelector("[data-vault-status]");
  const message = vault.querySelector("[data-vault-message]");

  vault.addEventListener("submit", async (event) => {
    event.preventDefault();
    status.textContent = "Verifying…";
    message.hidden = true;

    try {
      message.textContent = await openVault(vault.elements.phrase.value);
      status.textContent = "Unlocked.";
      message.hidden = false;
      message.focus();
    } catch {
      // n: 250,000 rounds of PBKDF2. if you're brute-forcing this, just read the pages.
      status.textContent = "Wrong phrase.";
    }
  });
}
